import { showMapInfoDialog } from '../../../../shared/scripts/ui_popup/showMapInfoDialog.ts';
import { MapDataController } from '../../../../../shared/map_data/MapDataController.ts';
import { UIUtilsEjsVariables } from '../../../../shared/scripts/UIUtilsEjsVariables.ts';
import { UIComponentItemScroll } from '../../../../shared/scripts/ui_components/item_scroll/UIComponentItemScroll.ts';
import { ClientUserState } from '../../../../shared/scripts/ClientUserState.ts';
import { MapSettingEnum } from '@colonist/game-base-types';
import { ColonistMembershipPerkType } from '@colonist/lobby-types';
import { socket } from '../../../../shared/scripts/EntryShared.ts';
export class UIRoomCenterSettingsMapController {
    update(newRoomState) {
        const shouldUpdate = this.shouldUpdate(newRoomState);
        const shouldResetSelector = this.shouldResetMapSelector(newRoomState);
        this.roomState = newRoomState;
        if (shouldUpdate) this.updateMapSelector();
        if (shouldResetSelector) this.resetMapSelector();
    }
    load(roomState) {
        this.roomState = roomState;
        if (this.mapSelector == undefined) {
            this.createMapSelector();
            return;
        }
        this.updateMapSelector();
    }
    updateInteractabilityOfElements(isGuest) {
        this.mapSelector.updateInteractabilityOfElements(isGuest);
    }
    createMapSelector() {
        const mapItemData = this.getMapItemData();
        this.mapSelector = new UIComponentItemScroll(this.mapSelectionDiv, mapItemData);
    }
    updateMapSelector() {
        const mapItemData = this.getMapItemData();
        this.mapSelector.update(mapItemData);
    }
    resetMapSelector() {
        this.mapSelector.resetScroll();
    }
    getMapItemData() {
        const compatibleMapData = MapDataController.getMapDataCompatibleWithGameMode(this.roomState.gameSetting.modeSetting);
        const userState = ClientUserState.userState;
        const mapItemData = [];
        for (const mapData of compatibleMapData){
            if (!mapData.isActive) continue;
            const isMapAvailable = this.isMapAvailable(mapData, userState);
            const isMapSelected = this.isMapSelected(mapData);
            const clickAction = ()=>{
                socket.roomClient.setMap(mapData.mapEnum);
            };
            const displayInfoAction = ()=>{
                showMapInfoDialog(mapData);
            };
            const bannerText = UIRoomCenterSettingsMapController.shouldShowWeeklyFreeBanner(mapData, userState) ? {
                key: 'strings:roomPage.options.map.weeklyFree'
            } : undefined;
            const itemData = {
                name: UIRoomCenterSettingsMapController.getMapName(mapData),
                image: mapData.image,
                available: isMapAvailable,
                selected: isMapSelected,
                bannerText: bannerText,
                clickAction: clickAction,
                infoAction: displayInfoAction,
                showInfoIcon: true
            };
            mapItemData.push(itemData);
        }
        return mapItemData;
    }
    isMapAvailable(mapData, userState) {
        if (this.roomState.isTestFreeExpansionsAndMaps) return true;
        if (this.roomState.isTournament) return true;
        if (mapData.mapEnum == UIUtilsEjsVariables.freeMap) return true;
        if (mapData.isMapPremium() == false) return true;
        if (userState === null || userState === void 0 ? void 0 : userState.items.hasAccessToPremiumMap(mapData)) return true;
        return false;
    }
    isMapSelected(mapData) {
        return mapData.mapEnum == this.roomState.gameSetting.mapSetting;
    }
    static shouldShowWeeklyFreeBanner(mapData, userState) {
        if (userState === null || userState === void 0 ? void 0 : userState.items.isPerkAvailable(ColonistMembershipPerkType.AllMaps)) return false;
        if (mapData.mapEnum == UIUtilsEjsVariables.freeMap) return true;
        return false;
    }
    shouldUpdate(newRoomState) {
        const didModeChange = this.roomState.gameSetting.modeSetting != newRoomState.gameSetting.modeSetting;
        const didMapChange = this.roomState.gameSetting.mapSetting != newRoomState.gameSetting.mapSetting;
        if (didModeChange) return true;
        if (didMapChange) return true;
        return false;
    }
    shouldResetMapSelector(newRoomState) {
        const didModeChange = this.roomState.gameSetting.modeSetting != newRoomState.gameSetting.modeSetting;
        return didModeChange;
    }
    static getMapName(mapData) {
        switch(mapData.mapEnum){
            case MapSettingEnum.Classic56P:
                return {
                    key: 'strings:colonistCommon.gameMaps.classic.56P.abbreviation'
                };
            case MapSettingEnum.Classic78P:
                return {
                    key: 'strings:colonistCommon.gameMaps.classic.78P.abbreviation'
                };
            default:
                return mapData.name;
        }
    }
    constructor(){
        this.mapSelectionDiv = document.getElementById('room_center_map_settings');
    }
}
